function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module cloud-services-core/token
 */

/* globals XMLHttpRequest, setTimeout, clearTimeout, atob */
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
var DEFAULT_OPTIONS = {
  autoRefresh: true
};
var DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME = 3600000;
/**
 * Class representing the token used for communication with CKEditor Cloud Services.
 * Value of the token is retrieving from the specified URL and is refreshed every 1 hour by default.
 *
 * @mixes ObservableMixin
 */

var Token = /*#__PURE__*/function () {
  /**
   * Creates `Token` instance.
   * Method `init` should be called after using the constructor or use `create` method instead.
   *
   * @param {String|Function} tokenUrlOrRefreshToken Endpoint address to download the token or a callback that provides the token. If the
   * value is a function it has to match the {@link module:cloud-services-core/token~refreshToken} interface.
   * @param {Object} options
   * @param {String} [options.initValue] Initial value of the token.
   * @param {Boolean} [options.autoRefresh=true] Specifies whether to start the refresh automatically.
   */
  function Token(tokenUrlOrRefreshToken) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    _classCallCheck(this, Token);

    if (!tokenUrlOrRefreshToken) {
      /**
       * A `tokenUrl` must be provided as the first constructor argument.
       *
       * @error token-missing-token-url
       */
      throw new CKEditorError('token-missing-token-url', this);
    }

    if (options.initValue) {
      this._validateTokenValue(options.initValue);
    }
    /**
     * Value of the token.
     * The value of the token is null if `initValue` is not provided or `init` method was not called.
     * `create` method creates token with initialized value from url.
     *
     * @name value
     * @member {String} #value
     * @observable
     * @readonly
     */


    this.set('value', options.initValue);
    /**
     * Base refreshing function.
     *
     * @private
     * @member {String|Function} #_refresh
     */

    if (typeof tokenUrlOrRefreshToken === 'function') {
      this._refresh = tokenUrlOrRefreshToken;
    } else {
      this._refresh = function () {
        return defaultRefreshToken(tokenUrlOrRefreshToken);
      };
    }
    /**
     * @type {Object}
     * @private
     */


    this._options = Object.assign({}, DEFAULT_OPTIONS, options);
  }
  /**
   * Initializes the token.
   *
   * @returns {Promise.<module:cloud-services-core/token~Token>}
   */


  _createClass(Token, [{
    key: "init",
    value: function init() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (!_this.value) {
          _this.refreshToken().then(resolve).catch(reject);

          return;
        }

        if (_this._options.autoRefresh) {
          _this._registerRefreshTokenTimeout();
        }

        resolve(_this);
      });
    }
    /**
     * Refresh token method. Useful in a method form as it can be override in tests.
     * @returns {Promise.<String>}
     */

  }, {
    key: "refreshToken",
    value: function refreshToken() {
      var _this2 = this;

      return this._refresh().then(function (value) {
        _this2._validateTokenValue(value);

        _this2.set('value', value);

        if (_this2._options.autoRefresh) {
          _this2._registerRefreshTokenTimeout();
        }
      }).then(function () {
        return _this2;
      });
    }
    /**
     * Destroys token instance. Stops refreshing.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this._tokenRefreshTimeout);
    }
    /**
     * Checks whether the provided token follows the JSON Web Tokens (JWT) format.
     *
     * @protected
     * @param {String} tokenValue The token to validate.
     */

  }, {
    key: "_validateTokenValue",
    value: function _validateTokenValue(tokenValue) {
      // The token must be a string.
      var isString = typeof tokenValue === 'string'; // The token must be a plain string without quotes ("").

      var isPlainString = !/^".*"$/.test(tokenValue); // JWT token contains 3 parts: header, payload, and signature.
      // Each part is separated by a dot.

      var isJWTFormat = isString && tokenValue.split('.').length === 3;

      if (!(isPlainString && isJWTFormat)) {
        /**
         * The provided token must follow the [JSON Web Tokens](https://jwt.io/introduction/) format.
         *
         * @error token-not-in-jwt-format
         */
        throw new CKEditorError('token-not-in-jwt-format', this);
      }
    }
    /**
     * Registers a refresh token timeout for the time taken from token.
     *
     * @protected
     */

  }, {
    key: "_registerRefreshTokenTimeout",
    value: function _registerRefreshTokenTimeout() {
      var _this3 = this;

      var tokenRefreshTimeoutTime = this._getTokenRefreshTimeoutTime();

      clearTimeout(this._tokenRefreshTimeout);
      this._tokenRefreshTimeout = setTimeout(function () {
        _this3.refreshToken();
      }, tokenRefreshTimeoutTime);
    }
    /**
     * Returns token refresh timeout time calculated from expire time in the token payload.
     *
     * If the token parse fails or the token payload doesn't contain, the default DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME is returned.
     *
     * @protected
     * @returns {Number}
     */

  }, {
    key: "_getTokenRefreshTimeoutTime",
    value: function _getTokenRefreshTimeoutTime() {
      try {
        var _this$value$split = this.value.split('.'),
            _this$value$split2 = _slicedToArray(_this$value$split, 2),
            binaryTokenPayload = _this$value$split2[1];

        var _JSON$parse = JSON.parse(atob(binaryTokenPayload)),
            tokenExpireTime = _JSON$parse.exp;

        if (!tokenExpireTime) {
          return DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME;
        }

        var tokenRefreshTimeoutTime = Math.floor((tokenExpireTime * 1000 - Date.now()) / 2);
        return tokenRefreshTimeoutTime;
      } catch (err) {
        return DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME;
      }
    }
    /**
     * Creates a initialized {@link module:cloud-services-core/token~Token} instance.
     *
     * @param {String|Function} tokenUrlOrRefreshToken Endpoint address to download the token or a callback that provides the token. If the
     * value is a function it has to match the {@link module:cloud-services-core/token~refreshToken} interface.
     * @param {Object} options
     * @param {String} [options.initValue] Initial value of the token.
     * @param {Boolean} [options.autoRefresh=true] Specifies whether to start the refresh automatically.
     * @returns {Promise.<module:cloud-services-core/token~Token>}
     */

  }], [{
    key: "create",
    value: function create(tokenUrlOrRefreshToken) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
      var token = new Token(tokenUrlOrRefreshToken, options);
      return token.init();
    }
  }]);

  return Token;
}();

mix(Token, ObservableMixin);
/**
 * This function is called in a defined interval by the {@link ~Token} class. It also can be invoked manually.
 * It should return a promise, which resolves with the new token value.
 * If any error occurs it should return a rejected promise with an error message.
 *
 * @function refreshToken
 * @returns {Promise.<String>}
 */

/**
 * @private
 * @param {String} tokenUrl
 */

function defaultRefreshToken(tokenUrl) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', tokenUrl);
    xhr.addEventListener('load', function () {
      var statusCode = xhr.status;
      var xhrResponse = xhr.response;

      if (statusCode < 200 || statusCode > 299) {
        /**
         * Cannot download new token from the provided url.
         *
         * @error token-cannot-download-new-token
         */
        return reject(new CKEditorError('token-cannot-download-new-token', null));
      }

      return resolve(xhrResponse);
    });
    xhr.addEventListener('error', function () {
      return reject(new Error('Network Error'));
    });
    xhr.addEventListener('abort', function () {
      return reject(new Error('Abort'));
    });
    xhr.send();
  });
}

export default Token;